import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getPayrollContainers() {
    return axiosIns.get('/v2/employee/payroll/payroll_aggregation_containers')
  },
  getPayrollContainer(id, {
    date,
    startDate,
    interval = 'monthly',
    isToday = false,
  }) {
    return axiosIns.get(
      `/v2/employee/payroll/payroll_aggregation_containers/${id}`,
      {
        params: snakecaseKeys({
          date,
          startDate,
          interval,
          isToday,
        }),
      },
    )
  },
  getAssignedUsers(containerId) {
    return axiosIns.get(`/v2/employee/payroll/payroll_aggregation_containers/${containerId}/assigned_users`)
  },
  getAvailableUsers(containerId) {
    return axiosIns.get(`/v2/employee/payroll/payroll_aggregation_containers/${containerId}/available_users`)
  },
  updateUsers(containerId, userIds) {
    return axiosIns.put(
      `/v2/employee/payroll/payroll_aggregation_containers/${containerId}/update_users`,
      snakecaseKeys({ userIds }),
    )
  },
}
